import { initializeApp, type FirebaseOptions } from 'firebase/app'
import { getMessaging } from 'firebase/messaging'
import { getMessaging as getMessagingSW } from 'firebase/messaging/sw'

const app = initializeApp(process.env.FIREBASE_OPTIONS as FirebaseOptions)

export const messaging = () => getMessaging(app)
export const messagingSW = () => getMessagingSW(app)
